import { computed } from 'vue';
import { useIdentityStore } from '@/stores/identity';
import { useFlagStore } from '@/stores/flag';
import { ORGANIZATION, ORGANIZATION_USER } from '@/models/auth/permissions.enum';

export function useListeningPermissions() {
  const identityStore = useIdentityStore();
  const flagStore = useFlagStore();

  // TODO [SC-165195]: Remove all the feature flags once the AIDE functionality is implemented
  const audioEnabled = computed(() => flagStore.ready && flagStore.flags.slAudio);
  const impressionsEnabled = computed(() => flagStore.ready && flagStore.flags.slImpressions);
  const organizationCanAccessSocialListening = computed(() =>
    identityStore.guard(ORGANIZATION.LISTENING.CAN_ACCESS_SOCIAL_LISTENING),
  );

  const organizationUserCanAccessSocialListening = computed(() =>
    identityStore.guard(ORGANIZATION_USER.LISTENING.CAN_ACCESS_SOCIAL_LISTENING),
  );

  const canAccessSocialListening = computed(
    () =>
      organizationCanAccessSocialListening.value && organizationUserCanAccessSocialListening.value,
  );

  const canAccessYoutubeCompliance = computed(
    () => flagStore.ready && flagStore.flags.youtubeCompliance,
  );

  const canAccessGDIHeadersAndFilters = computed(
    () => flagStore.ready && flagStore.flags.gdiHeadersAndFilters,
  );

  const canAccessSocialListeningGDI = computed(
    () => flagStore.ready && flagStore.flags.socialListeningGdi,
  );

  const canAccessNewShareOfVoice = computed(
    () => flagStore.ready && flagStore.flags.slShareOfVoice,
  );

  const hasAccessToPremiumAnalytics = computed(() => {
    const subscriptions = Object.values(identityStore.subscriptions?.brand ?? {}).flat();
    return subscriptions.some((sub) => sub.dhProduct?.label === 'premium_analytics');
  });

  const canAccessExcludeAccounts = computed(
    () => flagStore.ready && flagStore.flags.slExcludeAccounts,
  );

  return {
    audioEnabled,
    impressionsEnabled,
    organizationCanAccessSocialListening,
    organizationUserCanAccessSocialListening,
    canAccessSocialListening,
    canAccessYoutubeCompliance,
    canAccessGDIHeadersAndFilters,
    canAccessSocialListeningGDI,
    canAccessNewShareOfVoice,
    hasAccessToPremiumAnalytics,
    canAccessExcludeAccounts,
  };
}
